import type { AuthError } from './auth-client-adapter'

export type AuthStatus = 'unknown' | 'loggingIn' | 'loggedOut' | 'loggedIn' | 'error'

export function formatAuthError(error: AuthError): string {
  return error.message
}
